/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayerNoteDtoResult } from '../../models/player-note-dto-result';
import { UpdatePlayerNoteCommand } from '../../models/update-player-note-command';

export interface ApiPlayerNotesPut$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params {
      body?: UpdatePlayerNoteCommand
}

export function apiPlayerNotesPut$JsonOdataMetadataNoneOdataStreamingFalse$Any(http: HttpClient, rootUrl: string, params?: ApiPlayerNotesPut$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerNoteDtoResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerNotesPut$JsonOdataMetadataNoneOdataStreamingFalse$Any.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=none;odata.streaming=false');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerNoteDtoResult>;
    })
  );
}

apiPlayerNotesPut$JsonOdataMetadataNoneOdataStreamingFalse$Any.PATH = '/api/player-notes';
